import {
  Component,
  EventEmitter, Input,
  Output,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import {
  ProjectSelectDialogComponent
} from './project-select-dialog/project-select-dialog.component';
import { Project } from '../../../../model/project.model';
import { StoreService } from '../../../../services/store.service';

@Component({
  selector: 'project-selection',
  templateUrl: './project-selection.component.html',
  styleUrls: ['./project-selection.component.scss']
})
export class ProjectSelectionComponent {

  @Output() projectChanged = new EventEmitter<Project>;
  @Input() disabled: boolean = false;

  constructor(
    private _dialog: MatDialog,
    public store: StoreService
  ) {
  }
  changeProject() {
    const dialogRef = this._dialog.open(ProjectSelectDialogComponent, {
      position: {
        top: "75px"
      },
    });
    dialogRef.afterClosed().subscribe(project => {
      if (project) {
        this.projectChanged.emit(project);
        this.store.setSelectedProject(project);
      }
    })
  }
}
